import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cx } from './cx.js';

/**
 * The line a screen shows while it waits for its data.
 *
 * Six screens wrote this by hand as a muted paragraph with `role="status"`,
 * and the copies had begun to drift. The role is the part a copy forgets and
 * nobody sees go missing: it is what makes a reader say "Loading" rather than
 * nothing, the same scar `Banner` records. So the line owns it, and the copy
 * defaults to `common.loading`.
 */

export interface LoadingLineProps {
  /** What is being waited for, when "Loading" alone would not say. */
  readonly children?: ReactNode;
  /** Layout only. The look is the line's. */
  readonly className?: string | undefined;
}

export function LoadingLine({ children, className }: LoadingLineProps): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <p className={cx('text-muted', className)} role="status">
      {children ?? t('common.loading')}
    </p>
  );
}
